export function findColorByHex(hexValue, selected) {
  for (const palette of selected) {
    for (const color of palette.color) {
      if (color.hex === hexValue) {
        return true;
      }
    }
  }
  return false;
}
